import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

/*
 * Exported because not everything that talks to fleet-api is a fetch: the map tiles
 * are <img> elements, and their addresses are built by hand in stores/mapSources.ts.
 * One constant rather than the same string written twice, which would drift.
 */
export const API_BASE_URL = '/api/fleet-api/v1'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: API_BASE_URL,
        options: {
            /*
             * The service says why it refused — { error: { code, message } } — and
             * useFetch drops the body of a failed response unless told to keep it.
             * Without this every refusal would read "an error occurred" in the UI
             * while the reason sat unread in the response.
             */
            updateDataOnError: true,
            beforeFetch({ options }) {
                const headers = new Headers(options.headers)
                headers.set('Authorization', `Bearer ${appStore.getJWT()}`)
                options.headers = headers

                return { options }
            },
            async onFetchError(ctx) {
                if (ctx.response?.status === 401) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }

                return ctx
            },
        },
    })

    return { fetch }
})
